import { Routes, Route, BrowserRouter as Router, Outlet } from "react-router-dom";
import * as Pages from "pages";
import { Layout } from "components/layout";
import PrivateRoute from "./utils";
type ComponentType = {
  children?: React.ReactNode;
}

const AppRoutes = () => {

  const SidebarLayout = ({ children }: ComponentType) => (
    <Layout>
      {/* <PrivateRoute element={children} /> */}
      <Outlet />
    </Layout>
  );
  return (
    <Router>
      <Routes>
        <Route path="*" element={<Pages.ErrorPages status="404" />} />
        <Route path="/" element={<SidebarLayout />} >

          <Route path="/" element={<Pages.HomePage />} />
          <Route path="/configurations/companies" element={<Pages.CompanyPage />} />
          <Route path="/configurations/departments" element={<Pages.DepartmentPage />} />
          <Route path="/settings/users" element={<Pages.EmployeePage />} />
          <Route path="/configurations/roles" element={<Pages.RolePage />} />
          <Route
            path="/settings/users/details"
            element={<Pages.EmployeeDetailsPage />}
          />
          <Route path="/tasks/" element={<Pages.TaskPage />} />
          <Route path="/tasks/details" element={<Pages.TaskDetailsPage />} />
          <Route path="/pending-tasks" element={<Pages.TaskPendingPage />} />
          <Route path="/completed-tasks" element={<Pages.TaskCompletedPage />} />
          <Route
            path="/inprogress-tasks"
            element={<Pages.TaskInProgressPage />} />

          <Route path="/hr" element={<Pages.WelcomePage page="HR" />} />
          <Route path="/finance" element={<Pages.WelcomePage page="Finance" />} />
          <Route
            path="/procurement"
            element={<Pages.WelcomePage page="Procurement" />}
          />
          <Route
            path="/projects"
            element={<Pages.WelcomePage page="Projects" />}
          />
        </Route>

      </Routes>
    </Router>
  );
};
export default AppRoutes;
